import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ManualTagsState {
	manualTagsСhanged: boolean; // Флаг, что теги были изменены (добавлены/удалены)
}

const initialState: ManualTagsState = {
	manualTagsСhanged: false,
};

const manualTagsSlice = createSlice({
	name: 'manualTags',
	initialState,
	reducers: {
		setTagsChanged: (state, action: PayloadAction<boolean>) => {
			state.manualTagsСhanged = action.payload;
		},
	},
});

export const { setTagsChanged } = manualTagsSlice.actions;
export default manualTagsSlice.reducer;
